import React,{useEffect} from "react";
import {useSelector , useDispatch} from "react-redux";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from 'yup';
import { loginUserAction } from "../redux/slices/userSlices";
import { Link } from "react-router-dom";
import '../styles/login.css'
import Message from "./Message";

const formSchema = Yup.object({
    email : Yup.string().required("Email is required"),
    password : Yup.string().required("Password is required"),
});


export default function Login(){
    const storeData  = useSelector(store => store.users);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {user,prevLink} = storeData;

    const formik = useFormik({
        initialValues :{
            name : "",
            password : "",
        },

        onSubmit : (values)=>{
            dispatch(loginUserAction(values));
        },

        validationSchema : formSchema,
    })



    useEffect(()=>{
        if(user){
            navigate(prevLink);
        }
    },[user,navigate,prevLink])

    return (
      <>
      <Message/>
      <div id="main">
        <div className="log-in-container">
            <form className="log-in-form" onSubmit={formik.handleSubmit}>
                <div className="form-title">Welcome Back! </div>
                <div className="form-footer">Dont have an Account?  <Link to="/register"  className="reg">Register</Link></div>
                <div className="name-inputs">
                    <label for="first-name" className="input-label">Email</label>
                    <input type="email" id="email" className="input-value" placeholder="Enter Username" value={formik.values.email} onChange={formik.handleChange("email")} required/>
                </div>
                <div className="password-group">
                    <label for="password" className="input-label">Password</label>
                    <input type="password" id="password" className="input-value" placeholder="Enter password" value={formik.values.password} onChange={formik.handleChange("password")} required/>
                </div>

                <div className="form-actions">
                    <button type="submit" className="create-account-btn">Login</button>
                </div>
                
                <div className="additional-actions"><Link to="/forgot-password-reset" className="forgot-password">Forgot password?</Link> </div>
            </form>
        </div>
      </div>
      </>
    )
}